<div class="email-templates-container">
  <div class="templates-list-panel">
    <div class="panel-header">
      <h3>Templates</h3>
      <div class="header-buttons">
        <button kendoButton fillMode="outline" (click)="openDesigner()">
          <span class="k-icon k-font-icon k-i-image-edit"></span> Visual Designer
        </button>
        <button kendoButton themeColor="primary" (click)="createNew()">
          <span class="k-icon k-font-icon k-i-plus"></span> New Template
        </button>
      </div>
    </div>

    <kendo-grid
      [data]="templates"
      [loading]="loading"
      [selectable]="{ mode: 'single' }"
      (selectionChange)="onSelectionChange($event)"
      class="templates-grid"
    >
      <kendo-grid-column field="name" title="Name" [width]="180"></kendo-grid-column>
      <kendo-grid-column field="eventType" title="Event Type" [width]="140"></kendo-grid-column>
      <kendo-grid-column field="isActive" title="Active" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [class.active-badge]="dataItem.isActive" [class.inactive-badge]="!dataItem.isActive">
            {{ dataItem.isActive ? 'Yes' : 'No' }}
          </span>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>

  <div class="template-editor-panel" *ngIf="selectedTemplate || isNew">
    <div class="panel-header">
      <h3>{{ isNew ? 'New Template' : selectedTemplate?.name }}</h3>
      <div class="header-actions" *ngIf="!isEditing">
        <button kendoButton (click)="editTemplate()">
          <span class="k-icon k-font-icon k-i-edit"></span> Edit
        </button>
        <button kendoButton (click)="previewTemplate()">
          <span class="k-icon k-font-icon k-i-preview"></span> Preview
        </button>
        <button kendoButton themeColor="error" (click)="deleteTemplate()">
          <span class="k-icon k-font-icon k-i-delete"></span> Delete
        </button>
      </div>
    </div>

    <div *ngIf="!isEditing" class="template-view">
      <div class="info-row">
        <label>Event Type:</label>
        <span>{{ selectedTemplate?.eventType }}</span>
      </div>
      <div class="info-row">
        <label>Subject:</label>
        <span>{{ selectedTemplate?.subject }}</span>
      </div>
      <div class="info-row">
        <label>Status:</label>
        <span [class.active-badge]="selectedTemplate?.isActive" [class.inactive-badge]="!selectedTemplate?.isActive">
          {{ selectedTemplate?.isActive ? 'Active' : 'Inactive' }}
        </span>
      </div>
      <div class="info-row body-preview">
        <label>Body:</label>
        <div class="body-content" [innerHTML]="selectedTemplate?.body"></div>
      </div>

      <div class="test-email-section">
        <h4>Send Test Email</h4>
        <div class="test-email-form">
          <kendo-textbox
            [(ngModel)]="testEmailAddress"
            placeholder="Enter email address"
          ></kendo-textbox>
          <button kendoButton themeColor="primary" (click)="sendTestEmail()" [disabled]="!testEmailAddress">
            Send Test
          </button>
        </div>
      </div>
    </div>

    <form *ngIf="isEditing" [formGroup]="templateForm" class="template-form">
      <div class="form-row">
        <label>Name *</label>
        <kendo-textbox formControlName="name" placeholder="Template name"></kendo-textbox>
      </div>

      <div class="form-row">
        <label>Event Type *</label>
        <kendo-dropdownlist
          formControlName="eventType"
          [data]="eventTypes"
          [valuePrimitive]="true"
          (valueChange)="onEventTypeChange()"
        ></kendo-dropdownlist>
      </div>

      <div class="form-row">
        <label>Subject *</label>
        <div class="subject-input-wrapper">
          <kendo-textbox formControlName="subject" [placeholder]="'Email subject (supports variables like {{UserName}})'"></kendo-textbox>
          <div class="subject-variable-hint" *ngIf="templateForm.get('eventType')?.value">
            <span class="hint-text">Insert variable:</span>
            <div class="hint-variables">
              <button
                *ngFor="let variable of getVariablesForEventType(templateForm.get('eventType')?.value) | slice:0:5"
                kendoButton
                size="small"
                fillMode="flat"
                (click)="insertVariableIntoSubject(variable)"
                type="button"
                class="hint-variable-btn"
              >
                {{ '{{' + variable + '}}' }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row body-form-row">
        <div class="body-header">
          <label>Body *</label>
          <button kendoButton size="small" [fillMode]="showLivePreview ? 'solid' : 'outline'" 
                  [themeColor]="showLivePreview ? 'primary' : 'base'"
                  (click)="toggleLivePreview()" type="button">
            <span class="k-icon k-font-icon k-i-preview"></span> {{ showLivePreview ? 'Hide Preview' : 'Live Preview' }}
          </button>
        </div>

        <!-- Template Builder Toolbar -->
        <div class="template-builder-toolbar">
          <div class="toolbar-section">
            <span class="toolbar-label">Insert Elements:</span>
            <div class="toolbar-buttons">
              <button kendoButton size="small" fillMode="outline" (click)="toggleVariablePanel()" type="button"
                      [class.active]="showVariablePanel">
                <span class="k-icon k-font-icon k-i-parameter-string"></span> Variable
              </button>
              <button kendoButton size="small" fillMode="outline" (click)="toggleButtonBuilder()" type="button"
                      [class.active]="showButtonBuilder">
                <span class="k-icon k-font-icon k-i-link-horizontal"></span> Button
              </button>
            </div>
          </div>

          <div class="toolbar-section">
            <span class="toolbar-label">Quick Insert:</span>
            <div class="toolbar-buttons">
              <button kendoButton size="small" fillMode="flat" (click)="insertHeading()" type="button" title="Insert Heading">
                <span class="k-icon k-font-icon k-i-bold"></span>
              </button>
              <button kendoButton size="small" fillMode="flat" (click)="insertParagraph()" type="button" title="Insert Paragraph">
                <span class="k-icon k-font-icon k-i-text"></span>
              </button>
              <button kendoButton size="small" fillMode="flat" (click)="insertDivider()" type="button" title="Insert Divider">
                <span class="k-icon k-font-icon k-i-minus"></span>
              </button>
              <button kendoButton size="small" fillMode="flat" (click)="insertSpacer()" type="button" title="Insert Spacer">
                <span class="k-icon k-font-icon k-i-arrows-top-bottom"></span>
              </button>
              <button kendoButton size="small" fillMode="flat" (click)="insertInfoBox()" type="button" title="Insert Info Box">
                <span class="k-icon k-font-icon k-i-info-circle"></span>
              </button>
              <button kendoButton size="small" fillMode="flat" (click)="insertWarningBox()" type="button" title="Insert Warning Box">
                <span class="k-icon k-font-icon k-i-warning-circle"></span>
              </button>
            </div>
          </div>
        </div>

        <!-- Variable Panel -->
        <div class="builder-panel variable-panel" *ngIf="showVariablePanel">
          <div class="panel-header-row">
            <h4>Insert Variable</h4>
            <button kendoButton size="small" fillMode="flat" (click)="showVariablePanel = false" type="button">
              <span class="k-icon k-font-icon k-i-close"></span>
            </button>
          </div>

          <div class="variable-search">
            <kendo-textbox
              [(ngModel)]="variableSearchText"
              [ngModelOptions]="{standalone: true}"
              placeholder="Search variables..."
              size="small"
            >
              <ng-template kendoTextBoxPrefixTemplate>
                <span class="k-icon k-font-icon k-i-search"></span>
              </ng-template>
            </kendo-textbox>
          </div>

          <div class="variable-categories">
            <div class="variable-category" *ngFor="let category of filteredVariableCategories">
              <div class="category-header" (click)="toggleCategory(category)">
                <span class="k-icon" [class.k-i-arrow-chevron-down]="category.expanded" [class.k-i-arrow-chevron-right]="!category.expanded"></span>
                <span class="category-name">{{ category.name }}</span>
                <span class="category-count">{{ category.variables.length }}</span>
              </div>
              <div class="category-variables" *ngIf="category.expanded">
                <button
                  *ngFor="let variable of category.variables"
                  kendoButton
                  size="small"
                  fillMode="flat"
                  (click)="insertVariable(variable)"
                  type="button"
                  class="variable-chip"
                >
                  {{ '{{' + variable + '}}' }}
                </button>
              </div>
            </div>
          </div>

          <div class="variable-help">
            <span class="k-icon k-font-icon k-i-info-circle"></span>
            <span>Variables will be replaced with actual values when the email is sent.</span>
          </div>
        </div>

        <!-- Button Builder Panel -->
        <div class="builder-panel button-builder-panel" *ngIf="showButtonBuilder">
          <div class="panel-header-row">
            <h4>Insert Button</h4>
            <button kendoButton size="small" fillMode="flat" (click)="showButtonBuilder = false" type="button">
              <span class="k-icon k-font-icon k-i-close"></span>
            </button>
          </div>

          <div class="button-builder-form">
            <div class="builder-form-row">
              <label>Button Text *</label>
              <kendo-textbox
                [(ngModel)]="buttonConfig.text"
                [ngModelOptions]="{standalone: true}"
                placeholder="e.g., View Order, Approve Request"
                size="small"
              ></kendo-textbox>
            </div>

            <div class="builder-form-row">
              <label>Button URL *</label>
              <kendo-textbox
                [(ngModel)]="buttonConfig.url"
                [ngModelOptions]="{standalone: true}"
                [placeholder]="'e.g., ' + '{{' + 'AppUrl' + '}}' + '/orders/' + '{{' + 'OrderId' + '}}'"
                size="small"
              ></kendo-textbox>
              <div class="url-variable-hint">
                <span class="hint-label">Insert variable into URL:</span>
                <div class="url-variables">
                  <button
                    *ngFor="let variable of getVariablesForEventType(templateForm.get('eventType')?.value) | slice:0:6"
                    kendoButton
                    size="small"
                    fillMode="flat"
                    (click)="insertVariableIntoButtonUrl(variable)"
                    type="button"
                    class="url-variable-btn"
                  >
                    {{ '{{' + variable + '}}' }}
                  </button>
                </div>
              </div>
            </div>

            <div class="builder-form-row">
              <label>Button Style</label>
              <div class="button-style-options">
                <div
                  *ngFor="let style of buttonStyles"
                  class="style-option"
                  [class.selected]="buttonConfig.style === style.value"
                  (click)="buttonConfig.style = style.value"
                >
                  <span class="style-preview" [style.backgroundColor]="style.color"></span>
                  <span class="style-label">{{ style.label }}</span>
                </div>
              </div>
            </div>

            <div class="button-preview-section" *ngIf="buttonConfig.text">
              <label>Preview:</label>
              <div class="button-preview">
                <span
                  class="preview-button"
                  [style.backgroundColor]="getButtonStyleColor(buttonConfig.style)"
                >
                  {{ buttonConfig.text }}
                </span>
              </div>
            </div>

            <div class="builder-actions">
              <button kendoButton size="small" (click)="resetButtonConfig()" type="button">Reset</button>
              <button kendoButton size="small" themeColor="primary" (click)="insertButton()" type="button"
                      [disabled]="!buttonConfig.text || !buttonConfig.url">
                Insert Button
              </button>
            </div>
          </div>
        </div>

        <kendo-editor
          #bodyEditor
          formControlName="body"
          [style.height.px]="300"
          (valueChange)="showLivePreview && updateLivePreview()"
        >
        </kendo-editor>
        
        <!-- Live Preview Panel -->
        <div class="live-preview-panel" *ngIf="showLivePreview">
          <div class="preview-header">
            <h4>
              <span class="k-icon k-font-icon k-i-eye"></span>
              Live Preview
            </h4>
            <span class="preview-hint">Variables are rendered with sample data</span>
          </div>
          <div class="preview-subject" *ngIf="templateForm.get('subject')?.value">
            <span class="subject-label">Subject:</span>
            <span class="subject-value" [innerHTML]="getRenderedSubject()"></span>
          </div>
          <div class="preview-body">
            <div class="email-preview-container" [innerHTML]="livePreviewHtml"></div>
          </div>
          <div class="preview-legend">
            <div class="legend-item">
              <span class="legend-sample"></span>
              <span>Rendered variable (sample data)</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row checkbox-row">
        <kendo-switch formControlName="isActive"></kendo-switch>
        <label>Active</label>
      </div>

      <div class="form-actions">
        <button kendoButton (click)="previewTemplate()" type="button" *ngIf="templateForm.get('body')?.value">
          <span class="k-icon k-font-icon k-i-preview"></span> Preview
        </button>
        <button kendoButton (click)="cancelEdit()" type="button">Cancel</button>
        <button kendoButton themeColor="primary" (click)="saveTemplate()" [disabled]="templateForm.invalid">
          {{ isNew ? 'Create' : 'Save' }}
        </button>
      </div>
    </form>
  </div>

  <div class="template-editor-panel empty-state" *ngIf="!selectedTemplate && !isNew">
    <div class="empty-message">
      <span class="k-icon k-font-icon k-i-email k-icon-xl"></span>
      <p>Select a template from the list or create a new one</p>
    </div>
  </div>
</div>

<kendo-dialog
  *ngIf="showPreview"
  title="Template Preview"
  (close)="showPreview = false"
  [width]="700"
  [height]="500"
>
  <div class="preview-content" [innerHTML]="previewHtml"></div>
  <kendo-dialog-actions>
    <button kendoButton (click)="showPreview = false">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>
